import { ErrorBoundary } from "@sentry/react";
import React, { useContext } from "react";
import "../../assets/styles/component/pageContainer.scss";
import { ErrorMsg } from "../AppMessages";
import { PasswordReset } from "../Modals";
import { DashboardBannerContext } from "../../context";

interface Props {
  iframeUrl: string;
  frameId: string;
  filter?: JSX.Element;
}

export const IframePageContent = (props: Props): JSX.Element => {
  const { iframeUrl, filter, frameId } = props;
  const { detailText, bannerText, showBanner, setBannerHovered } = useContext(DashboardBannerContext);

  return (
    <>
      {filter && <ErrorBoundary fallback={<ErrorMsg />}>{filter}</ErrorBoundary>}
      { showBanner && <div
                className={`dashboard_banner iframe_banner hide_on_mobile `}
                onMouseEnter={() => setBannerHovered(true)}
                onMouseLeave={() => setBannerHovered(false)}
              >
                <p>
                {bannerText}
                  <span className={"detail"}> {detailText}</span>
                </p>
              </div>
            }
      <div id="container">
        {/*Main content*/}
        <div className={"iframeWrapper"}>
          <iframe src={iframeUrl} frameBorder={0} allowFullScreen={true} id={frameId} data-test-id={frameId} />
        </div>
      </div>

      <PasswordReset />
    </>
  );
};

export const IframePageContentComingSoon = (props: Props): JSX.Element => {
  const { filter } = props;

  return (
    <>
      {filter && <ErrorBoundary fallback={<ErrorMsg />}>{filter}</ErrorBoundary>}
      <div id="container">
        {/*Main content*/}
        <div className={"no-data-tile"}>
          This dashboard page is in development and will be available soon in CEDAR home
        </div>
      </div>

      <PasswordReset />
    </>
  );
};
